export default __webpack_public_path__ + "static/download-sign-up-illustration-light-c6d01b0d812fa20c9b6e6db6cca8c57c.svg";